import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/Breadcrumbs";
import { Reveal } from "@/components/Reveal";
import { SITE_URL } from "@/lib/seo";

const sections = [
  { h: "1. Who we are", p: "LAK Atelier (\"we\", \"us\", \"the atelier\") is a boutique web design studio based in London, United Kingdom. We can be reached at info@lakatelier.com." },
  { h: "2. Information we collect", p: "We collect the information you provide to us through our enquiry form (such as your name, email, business details and project description), and basic analytics data to understand how visitors use the site." },
  { h: "3. How we use your information", p: "We use your enquiry information solely to respond to your enquiry and discuss your project. Analytics data is used in aggregate to improve the website. We do not sell or share personal information with third parties for marketing." },
  { h: "4. Lawful basis", p: "Under UK GDPR our lawful bases for processing are legitimate interest (responding to enquiries) and consent (analytics). You may withdraw consent at any time." },
  { h: "5. Storage and security", p: "Enquiry data is stored on secure servers within the European Economic Area. We apply reasonable technical and organisational measures to protect it." },
  { h: "6. Your rights", p: "You have the right to access, correct, delete or restrict the personal data we hold about you. To exercise these rights, please email info@lakatelier.com." },
  { h: "7. Cookies", p: "We use a minimal number of essential cookies and, where consented, anonymous analytics cookies. No advertising cookies are used." },
  { h: "8. Changes to this policy", p: "We may update this policy from time to time. The latest version will always be available on this page." },
];

export default function Privacy() {
  const crumbs = [
    { name: "Home", url: `${SITE_URL}/` },
    { name: "Privacy Policy", url: `${SITE_URL}/privacy` },
  ];
  return (
    <main className="pt-32 sm:pt-40 bg-lak-bg">
      <Seo
        title="Privacy Policy"
        description="How LAK Atelier collects, uses and protects personal information shared through this website. UK GDPR compliant."
        breadcrumbs={crumbs}
      />
      <section className="lak-section pb-24">
        <div className="max-w-3xl mx-auto px-6 sm:px-10 lg:px-14">
          <Breadcrumbs items={crumbs} className="mb-10" />
          <Reveal><span className="eyebrow">Legal &middot; Privacy</span></Reveal>
          <Reveal delay={0.1}>
            <h1 className="mt-8 font-serif text-5xl sm:text-6xl lg:text-7xl font-light tracking-tight leading-[1.02]">
              Privacy Policy
            </h1>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 eyebrow text-lak-soft">Last updated: {new Date().toLocaleDateString("en-GB", { year: "numeric", month: "long" })}</p>
          </Reveal>
          <div className="mt-12 space-y-10 md:text-left">
            {sections.map((s) => (
              <Reveal key={s.h}>
                <h2 className="font-serif text-2xl sm:text-3xl font-light tracking-tight">{s.h}</h2>
                <p className="mt-3 text-lak-soft leading-relaxed">{s.p}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
